"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAndroidVariantCommand = void 0;
const AbstractCreateVariantCommand_1 = require("./AbstractCreateVariantCommand");
class CreateAndroidVariantCommand extends AbstractCreateVariantCommand_1.AbstractCreateVariantCommand {
    constructor(api, appId) {
        super(api, appId, 'android');
        this.withGoogleKey = (googleKey) => {
            this.def.googleKey = googleKey;
            return this;
        };
        this.withProjectNumber = (projectNumber) => {
            this.def.projectNumber = projectNumber;
            return this;
        };
        this.def.type = 'android';
    }
}
exports.CreateAndroidVariantCommand = CreateAndroidVariantCommand;
//# sourceMappingURL=CreateAndroidVariantCommand.js.map